
<template>
  <header class="fullscreen-element no-pad centered-text">
    <div class="fullbleed-color secondary-bg" v-bind:style=" { 'opacity': 1-opacityPercent } "></div>

      <div class="border border-top"></div>
      <div class="border border-bottom"></div>
      <div class="border border-left"></div>
      <div class="border border-right"></div>

      <div class="container masthead-container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left">
            <div class="masthead-inner">
              <div class="mast-logo-container" v-bind:class=" { 'sticky': pastTop } ">
                <img class="logo" :src="'static/img/common/newlogo_black.png'"/>    
            </div>
            <div class="masthead-camel">
              <img src="static/img/common/camel.png" />
            </div>
            <div class="down-arrow" v-show="opacityPercent < 0.1"><i class="fas fa-chevron-down"></i></div>
          </div>
        </div>
      </div>
    </div>

  </header>
</template>

<script>
import {commontools} from '../mixins/Styling'
// import Vue from 'vue'

export default {
  props: ['page'],
  mixins: [commontools],
  data: function () {
    return {
      myHeight: 0,
      opacityPercent: 1,
      pastTop: false,
      logoTop: 0
    }
  },
  methods: {
    handleScroll: function (val) {
      let scrolltop = window.scrollY
      this.pastTop =  ((window.innerHeight/2) - scrolltop <= 34) ? true : false
      this.opacityPercent = this.scrollPercent()
    },
    getLogoTop: function () { 
      // this.logoTop = (window.innerHeight / 2)
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted: function () {
  },
  computed: {
    // a computed getter
  }
}
</script>

<style>

header {
  padding: 0;
  position: relative;
}
.masthead-camel {
  width:50px;
  height:46px;
  top: 50%;
  position: absolute;
  left:50%;
  transform: translate3d(65px, 40px, 0) rotateZ(-20deg);
  -webkit-transform: translate3d(65px, 40px, 0) rotateZ(-20deg);
}
.fullbleed-color {
  position: absolute;
  top: 0;
  width: 100%;
  height: 200%;
}
.fullbleed-logo {
  position: absolute;top:0;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  background-size: auto 50px;
}
.masthead-container {
  position: relative;
  overflow: hidden;
}
.mast-logo-container {
  position: absolute;
  width: 100%;
  height: 44px;
  top:50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  -webkit-transform: translate3d(-50%, -50%, 0);
  text-align: center;
}


.masthead-inner {
  height: 100%;
  width:100%;
  position: relative;
}

.down-arrow {
  position: absolute;
  bottom: 25px;
  left:50%;
  transform: translate3d(-50%, 0%, 0);
  font-size: 30px;
  color: #000;
  animation: down-arrow-anim 2.5s infinite;
  -webkit-animation: down-arrow-anim 2.5s infinite;
}

@keyframes down-arrow-anim {
  0%, 30%, 60%    { transform: translate3d(-50%, 0%, 0); animation-timing-function: ease-in-out; }
  15%   { transform: translate3d(-50%, 20%, 0); animation-timing-function: ease-in-out; }
  45%   { transform: translate3d(-50%, 20%, 0); animation-timing-function: ease-in-out; }
}
@-webkit-keyframes down-arrow-anim {
  0%, 30%, 60%   { -webkit-transform: translate3d(-50%, 0%, 0); -webkit-animation-timing-function: ease-in-out; }
  15%   { -webkit-transform: translate3d(-50%, 20%, 0); -webkit-animation-timing-function: ease-in-out; }
  45%   { -webkit-transform: translate3d(-50%, 20%, 0); -webkit-animation-timing-function: ease-in-out; }
}

@media (min-width: 576px) {

}
@media (min-width: 768px) {
  .masthead-camel {
    width:60px;
    height:55px;
    transform: translate3d(75px, 50px, 0) rotateZ(-20deg);
    -webkit-transform: translate3d(75px, 50px, 0) rotateZ(-20deg);
  }
}
@media (min-width: 992px) {

}
@media (min-width: 1200px) {

}

</style>